import { Component, OnInit, Output, EventEmitter, Input, NgZone } from '@angular/core';
import { LoginResponse, LoginOptions, FacebookService } from 'ngx-facebook';
import { VariablesService, AuthService, StorageService, UtilService } from '../../../../shared/services';
import { IUser } from '../../../../shared/models/user.model';
import { MatDialog } from '@angular/material/dialog';
declare const clevertap;
@Component({
  selector: 'app-fb-login',
  templateUrl: './fb-login.component.html',
  styleUrls: ['./fb-login.component.scss']
})
export class FbLoginComponent implements OnInit {

  @Input() public label;
  @Input() public closeDialog = true;
  @Output() public loginResponse = new EventEmitter<IUser>();
  isLoading;
  constructor(
    public authService: AuthService,
    public fb: FacebookService,
    public storageService: StorageService,
    public utilService: UtilService,
    public variablesService: VariablesService,
    public dialog: MatDialog,
    public zone: NgZone
  ) { }

  ngOnInit() {
  }
  /**
   * Social login auth service call to
   * invoke the facebook UI for login
   */
  public socialSignIn() {
    this.isLoading = true;
    const options: LoginOptions = {
      scope: 'email',
      return_scopes: true,
      enable_profile_selector: true,
      auth_type: 'rerequest'
    };
    this.fb.login(options).then((response: LoginResponse) => {
      this.zone.run(() => {
        this.storageService.add('facebook', response.authResponse);
        this.authService.loginSocail(response.authResponse.accessToken).subscribe((res: any) => {
          this.afterLogin(res);
          this.isLoading = false;
          if (this.closeDialog) {
            this.dialog.closeAll();
          }
        });
      });
    }).catch(() => {
      this.zone.run(() => {
        this.isLoading = false;
      });
    });
  }
  /**
   * Get user profile
   */
  getUserData() {
    this.authService.getUserProfile().subscribe((res: any) => {
      this.pushDataLogin(res.data);
      this.utilService.setUserData(res.data);
      this.variablesService.userData.next(res.data);
      this.loginResponse.emit(res.data);
    });
  }
  /**After login hit */
  afterLogin(response) {
    response.data.user['isLoggedIn'] = true;
    this.utilService.setUser(response.data);
    this.getUserData();
    this.sessionLogin(response.data);
    this.utilService.isLoggedIn.next(true);
  }
  /**After Login System event send */
  pushDataLogin(user) {
    const data = {
      Site: {
        Identity: user.id,
        Name: user.full_name,
        Email: user.email,
        Phone: '+91' + user.phone_1,
        Entity_Type: user.entity_type
      }
    };
    if (user.gender && user.gender !== 'NA') {
      data.Site['Gender'] = user.gender;
    }
    clevertap.onUserLogin.push(data);
  }
  /**Session Login */
  sessionLogin(data) {
    const payload = new FormData();
    payload.append('token', data.token);
    payload.append('submitTokenLogin', '1');
    this.authService.sessionLogin(payload).subscribe(_ => _);
  }

}
